import { render, staticRenderFns } from "./ConfigValuesForm.vue?vue&type=template&id=e318d058"
import script from "./ConfigValuesForm.vue?vue&type=script&lang=js"
export * from "./ConfigValuesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports